import * as M from '@mantine/core';

import { InfoField } from '../../../../../../ui/infoField/InfoField';
import CustomSearch from '../../../../../../ui/search/customSearch';
import type { IAiAgentModelFilterForm } from '../types';

interface IAiAgentModelFilterSectionProps {
  filterForm: IAiAgentModelFilterForm;
  inputRef: React.RefObject<HTMLInputElement>;
  onChangeFilterForm: (nextFilter: Partial<IAiAgentModelFilterForm>) => void;
  onChangeSearchType: (value: string | null) => void;
  handleSearch: (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLInputElement>) => void;
  resetSearchInput: () => void;
  onReset: () => void;
}

const mgptUseYnOptions: Array<{ value: IAiAgentModelFilterForm['useYn']; label: string }> = [
  { value: 'all', label: '전체' },
  { value: 'Y', label: '연동' },
  { value: 'N', label: '미연동' },
];

export default function AiAgentModelFilterSection(props: IAiAgentModelFilterSectionProps) {
  const { filterForm, inputRef, onChangeFilterForm, onChangeSearchType, handleSearch, resetSearchInput, onReset } = props;

  return (
    <M.Box
      style={{
        borderTop: '1px solid var(--mantine-color-gray-3)',
        borderLeft: '1px solid var(--mantine-color-gray-3)',
      }}
    >
      <M.SimpleGrid cols={2} spacing={0} verticalSpacing={0} style={{ gridTemplateColumns: '180px minmax(0, 1fr)' }}>
        <InfoField label="학습 연동" labelAlign="left" contentAlign="left">
          <M.Flex gap="lg" wrap="wrap">
            {mgptUseYnOptions.map((option) => (
              <M.Checkbox
                key={option.value}
                label={option.label}
                size="sm"
                checked={filterForm.useYn === option.value}
                onChange={() => onChangeFilterForm({ useYn: option.value })}
              />
            ))}
          </M.Flex>
        </InfoField>
        <InfoField label="상세 검색" labelAlign="left" contentAlign="left">
          <M.Flex gap="sm" align="center" wrap="wrap" w="100%">
            <CustomSearch
              resetSearch={onReset}
              resetSearchInput={resetSearchInput}
              searchType={filterForm.searchType}
              setSearchType={onChangeSearchType}
              inputRef={inputRef}
              handleSearch={handleSearch}
              searchOptions={[
                {
                  value: 'assignedName',
                  label: '모델명',
                },
                {
                  value: 'productGroup',
                  label: '제품군명',
                },
                {
                  value: 'modifier',
                  label: '수정 담당자',
                },
              ]}
              placeholder="모델명으로 검색해주세요."
            />
          </M.Flex>
        </InfoField>
      </M.SimpleGrid>
    </M.Box>
  );
}
